import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import FooterSection from './footer-section'
import HereToHelp from './here-to-help'
import Legal from './legal'
import Socials from './socials'
import EmailCapture from '../../email-capture'
import * as E from '../../../elementor'
import classNames from 'classnames'

interface FooterProps {
  experimentA?: boolean
  emailCaptureSection?: E.Section<true>
}

const Footer: React.FC<FooterProps> = ({ experimentA = false, emailCaptureSection }) => {
  const result = useStaticQuery(graphql`
    query FooterQuery {
      allWpMenuItem(filter: {locations: {eq: GATSBY_FOOTER_MENU}, parentId: {eq: null}}) {
        footerMenuItems: nodes {
          label
          childItems {
            nodes {
              label
              childItems {
                nodes {
                  uri
                  label
                  cssClasses
                }
              }
            }
          }
        }
        totalCount
      }
    }
  `)

  const footerItems = result.allWpMenuItem.footerMenuItems
  const footerPrimaryHeader = 'We’re here when you need us'
  const footerSecondaryHeader = 'Learn how Rula can support your mental health journey'

  const firstSection = footerItems?.find(item => item.label === 'Rula')
  const secondSection = footerItems?.find(item => item.label !== 'Rula')

  return (
    <div data-testid='footer-wrapper' className='rula-footer-wrapper'>
      <div className={classNames({ 'rula-footer': true, 'includes-email-capture': !(emailCaptureSection == null) })}>
        <div className='footer-header'>
          <EmailCapture emailCaptureSection={emailCaptureSection} primaryHeader={footerPrimaryHeader} secondaryHeader={footerSecondaryHeader} />
          <Socials />
        </div>
        <FooterSection section={firstSection} isTopSection />
        {!experimentA ? <FooterSection section={secondSection} /> : null}
        <div className='bottom-email-capture'>
          <EmailCapture emailCaptureSection={emailCaptureSection} primaryHeader={footerPrimaryHeader} secondaryHeader={footerSecondaryHeader} />
          <hr className='footer-divider' />
        </div>
        <HereToHelp />
        <div className='bottom-socials'>
          <Socials />
        </div>
        <Legal />
      </div>
    </div>
  )
}

export default Footer
